@if (quote) {
  @if (quote?.new) {
    <ds-quote-card class="blue-theme" [quote]="quote?.new"> </ds-quote-card>
  }
  @if (quote?.current) {
    <ds-quote-card class="gray-theme" [quote]="quote?.current"> </ds-quote-card>
  }
}
